import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

export default function Authentication() {
  return (
    <div className="auth-settings">
      <h5 className="mb-3">Authentication Settings</h5>

      <div className="section-border">

        {/* Allow Registration */}
        <Row className="align-items-center form-row">
          <Col md={4} className="label-col">Allow Registration</Col>
          <Col md={8} className="d-flex align-items-center gap-3">
            <Form.Check type="switch" defaultChecked />
            <Form.Check type="checkbox" label="Invite Only" />
          </Col>
        </Row>

        {/* Verification Required */}
        <Row className="align-items-center form-row">
          <Col md={4} className="label-col">Verification Required</Col>
          <Col md={8}>
            <Form.Check type="switch" />
          </Col>
        </Row>

        {/* Verification Expired */}
        <Row className="align-items-center form-row">
          <Col md={4} className="label-col">Verification Expired</Col>
          <Col md={6}>
            <Form.Control defaultValue="ds" />
          </Col>
        </Row>

        {/* Referral System */}
        <Row className="align-items-center form-row">
          <Col md={4} className="label-col">Referral System</Col>
          <Col md={8}>
            <Form.Check type="switch" />
          </Col>
        </Row>

        {/* Login Type */}
        <Row className="align-items-center form-row">
          <Col md={4} className="label-col">Login Type</Col>
          <Col md={8} className="d-flex gap-3">
            <Form.Check type="radio" label="Mobile" name="loginType" />
            <Form.Check type="radio" label="Email" name="loginType" />
          </Col>
        </Row>

        {/* Password */}
        <Row className="align-items-center form-row">
          <Col md={4} className="label-col">Password</Col>
          <Col md={8}>
            <Form.Check type="switch" defaultChecked />
          </Col>
        </Row>

        {/* OTP System */}
        <Row className="align-items-center form-row">
          <Col md={4} className="label-col">OTP System</Col>
          <Col md={8}>
            <Form.Check type="switch" />
          </Col>
        </Row>

        {/* OTP Type */}
        <Row className="align-items-center form-row">
          <Col md={4} className="label-col">OTP Type</Col>
          <Col md={8} className="d-flex gap-3">
            <Form.Check type="radio" label="SMS OTP" name="otpType" />
            <Form.Check type="radio" label="Email OTP" name="otpType" />
          </Col>
        </Row>

        <hr className="divider" />

        {/* ACTION BUTTONS */}
        <div className="text-end">
          <Button variant="light" className="btn-cancel">Cancel</Button>
          <Button className="btn-orange ms-2">Save</Button>
        </div>

      </div>
      <style>
          {

               `
               /* BOX */
.section-border {
  border: 1px solid #e5e7eb;
  padding: 20px;
  border-radius: 8px;
  background: #fff;
}

/* ROW SPACING */
.form-row {
  margin-bottom: 18px;
}

/* LABEL */
.label-col {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}

/* INPUT WIDTH */
.auth-settings .form-control {
  height: 40px;
  max-width: 420px;
}

/* SWITCH COLOR */
.form-check-input:checked {
  background-color: #ff6a00;
  border-color: #ff6a00;
}

/* BUTTON */
.btn-orange {
  background: #ff6a00;
  border: none;
  color: #fff;
  padding: 6px 18px;
}

.btn-orange:hover {
  background: #e65c00;
}

.btn-cancel {
  padding: 6px 18px;
}

/* DIVIDER */
.divider {
  margin: 20px 0;
  border-top: 1px solid #e5e7eb;
}

/* MOBILE */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 6px;
  }

  .label-col {
    margin-bottom: 4px;
  }

  .auth-settings .form-control {
    width: 100%;
    max-width: 100%;
  }
}`
          }
      </style>
    </div>
  );
}